(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('videosLast', VideosLast)

    /** @ngInject */
    function VideosLast(HelperService, VideoService, AuthenticationService, PATHS) {
        function VideosLastController() {
            const vm = this;

            vm.getVideoImage = video => {
                return HelperService.imageResizePath('videos', video.Id, video.Image, 500, 300);
            }

            vm.init = () => {
                vm.videos = [];
                vm.isLoading = true;

                getVideos();
            }

            function getVideos() {
                HelperService.startLoading('.last-elements.videos');

                vm.isLoading = true;
                let userData = AuthenticationService.getUserData();
                let parameters = {
                    ResponsibilityId: userData.Responsibility.Id,
                    Active: true,
                    Highlight: true,
                    OrderBy: 'StartDate',
                    OrderDescending: false,
                    PerPage: 4,
                    Skip: 0
                };

                if (vm.excludeVideo)
                    parameters.ExcludeVideoId = vm.excludeVideoId;

                VideoService
                    .getAllByParameters(parameters, userData.Id)
                    .then(success => {
                        vm.videos = success.Videos;
                        vm.isLoading = false;
                        HelperService.stopLoading('.last-elements.videos');
                    }, error => {
                        vm.isLoading = false;
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.last-elements.videos');
                    })
            }
        }

        function link(scope, attrs, elem, ctrl) {
            ctrl.init();
        }

        return {
            bindToController: true,
            link: link,
            controller: VideosLastController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/videos-last/videos-last.html`,
            scope: {
                excludeVideoId: '=',
                resumed: '='
            }
        }
    }
}());